// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1REfP","buttons":"SendReceipts_buttons__1JtCi","email":"SendReceipts_email__1bvkb","bookApptTitle":"SendReceipts_bookApptTitle__3y5Tj"};